// extracted by mini-css-extract-plugin
module.exports = {"reviewer-selector":"reviewer-selector__15OiN","assignment":"assignment__1SqpC","dropdown":"dropdown__10MN8","clear-button":"clear-button__2XmcF","close-icon":"close-icon__1qork"};